import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment'
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from "rxjs";
import { AccountModel } from '../models/account.model';
import { EntityModel } from '../models/legalentity-model';
import { InfraService } from './infra.service';

@Injectable()
export class AccountService {
  private configUrl: string;

  constructor(private infraService: InfraService, private http: HttpClient) {
    //if (localStorage.getItem('selectedregion') == '1') {
    //  this.configUrl = environment.apiUrl + 'account';
    //}
    //else {
    //  this.configUrl = environment.apiUrlRow + 'account';
    //}
    this.infraService.infraDetails$.subscribe(data => {
      this.configUrl = data.WebEndPoint2 + 'account';
    });

    if (!this.infraService.isInfraDetailsAvailable && localStorage.getItem('selectedInfra') != undefined) {
      this.infraService.isInfraDetailsAvailable = true;
      this.infraService.setInfraDetails(localStorage.getItem('selectedInfra'));
    }
  }

  public getAllAccounts(entityid: EntityModel[], engagementid: number, mappingid: number, entityid2: EntityModel[]): Observable<AccountModel[]> {
    return this.http.post<AccountModel[]>(`${this.configUrl}/getAllAccounts`, { entityid: entityid, engagementid: engagementid, mappingid: mappingid, entityid2: entityid2});
    // .catch(this.handleError);${entityid}/${engagementid}/${mappingid}/${entityid2}
  }

  private handleError(error: Response) {
    return throwError(()=> error);
  }


}
